import { render, staticRenderFns } from "./PartnerContactPersons.vue?vue&type=template&id=2d9d2f89"
import script from "./PartnerContactPersons.vue?vue&type=script&lang=js"
export * from "./PartnerContactPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports